import React, { useState } from "react";
import { Button } from "../../design/button";
import { Dialog } from "../../design/dialog";
import SelectImportType, { ImportType } from "./components/SelectImportType";
import ImportCSV from "./components/ImportCSV";
import ImportFiling from "./components/ImportFiling/ImportFiling";
import ImportFile from "./components/ImportFile/ImportFile";
import { ArrowUpTrayIcon } from "@heroicons/react/20/solid";

interface Props {
  children?: React.ReactNode;
}

const ImportButton: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [importType, setImportType] = useState<ImportType["id"] | null>(null);
  return (
    <>
      <Button
        type="button"
        onClick={() => setIsOpen(true)}
        id="create_event_button"
      >
        {props.children ?? (
          <div className="flex items-center gap-2">
            <ArrowUpTrayIcon className="w-4 h-4" />
            <span className="hidden sm:block">Import Events</span>
          </div>
        )}
      </Button>

      <Dialog open={isOpen} onClose={setIsOpen}>
        {!importType && (
          <SelectImportType
            handleClose={() => setIsOpen(false)}
            onImportTypeSelected={(type) => setImportType(type)}
          />
        )}
        {importType === "csv" && (
          <ImportCSV handleClose={() => setImportType(null)} />
        )}
        {importType === "file" && (
          <ImportFile handleClose={() => setImportType(null)} />
        )}
        {importType === "filing" && (
          <ImportFiling handleClose={() => setImportType(null)} />
        )}
      </Dialog>
    </>
  );
};

export default ImportButton;
